import axios from 'axios'
import * as Config from '../config'

// NOTE: `instance` was only used by the `doctor` API block below, which is now
// commented out (the DoctorDetails screen is unreachable — its route is
// disabled in main/routes.js). Uncomment both together if that screen returns.
// const instance = axios.create({
//   headers: {
//     'Content-Type': 'application/json',
//   },
//   timeout: 1000000,
// })

// instance.interceptors.request.use(function (config) {
//   const token = localStorage.getItem('adminToken')
//   config.headers.Authorization = `Bearer ${token}`

//   return config
// })

// instance.interceptors.request.use(
//   (request) => {
//     return request
//   },
//   (error) => {
//     return Promise.reject(error)
//   },
// )

export const API = {
  // Book a Cab — public endpoints, no auth token required, so plain axios is
  // used instead of `instance` (which attaches an admin Bearer token).
  bookCab: {
    getTypeList: () => axios.get(`${Config.VEHICLE_TYPE}?page=1&size=100&display_type=active`),
    // NOTE: the Category API expects the (mis-spelled) key `vechile_type_id` —
    // do not "correct" it, the filter breaks. Same quirk as the admin panel.
    getCategoryList: (vehicleTypeId) =>
      axios.get(
        `${Config.VEHICLE_CATEGORY}?page=1&size=100&display_type=active&vechile_type_id=${vehicleTypeId}`,
      ),
    // Subcategories only exist for Passenger categories. This endpoint spells
    // the key correctly (`category_id`), unlike the category one above.
    getSubCategoryList: (categoryId) =>
      axios.get(
        `${Config.VEHICLE_SUBCATEGORY}?page=1&size=100&display_type=active&category_id=${categoryId}`,
      ),
    // Optional filters are only appended when set — sending `category_id=`
    // (empty) makes the API reject the request as a validation error.
    // banner_type is a display label with a space in it, so it must be encoded.
    getBanners: () =>
      axios.get(`${Config.BANNER}?banner_type=${encodeURIComponent(Config.BANNER_TYPE_HOME)}`),
    getNearbyVehicles: ({
      latitude,
      longitude,
      radius_km,
      vehicle_type_id,
      category_id,
      subcategory_id,
      page = 1,
      size = 100,
    }) => {
      const params = new URLSearchParams({ latitude, longitude, radius_km, page, size })
      if (vehicle_type_id) params.append('vehicle_type_id', vehicle_type_id)
      if (category_id) params.append('category_id', category_id)
      if (subcategory_id) params.append('subcategory_id', subcategory_id)
      return axios.get(`${Config.VEHICLE_NEARBY}?${params.toString()}`)
    },
  },
  // Legacy e-clinicx — user sign-up / sign-in / OTP screens are disabled.
  // Uncomment together with the watchers in main/redux/auth/saga.js.
  // authApi: {
  //   signUpUser: (data) => axios.post(Config.SIGN_UP_USER, data),
  //   signInUser: (data) => axios.post(Config.LOGIN_IN_OTP, data),
  //   userVerification: (data) => axios.post(Config.OTP, data),
  // },
  // Legacy e-clinicx — DoctorDetails screen is unreachable (route disabled)
  // doctor: {
  //   doctorDetails: (id) => instance.get(`${Config.DOCTOR}${id}`),
  //   bookAppointment: (data) =>
  //     instance.post(
  //       `${Config.BOOK_APPOINTMENT}${data?.doctor_id}?appointment_date=${data?.appointment_date}?visit_type_id=${data?.visit_type_id}?slot_type_id=${data?.slot_type_id}?status_type_id=${data?.status_type_id}`,
  //     ),
  //   getDoctorSlots: (doctor_id, visit_type_id) =>
  //     instance.get(
  //       `${Config.DOCTOR_SLOT_LIST}?doctor_id=${doctor_id}&visit_type_id=${visit_type_id}`,
  //     ),
  // },
}
